import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { KomitentObjekatUpisnoMesto } from './komitent-objekat-upisno-mesto';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-komitent-objekat-upisno-mesto',
  templateUrl: './komitent-objekat-upisno-mesto.component.html'
})
export class KomitentObjekatUpisnoMestoComponent extends BaseModalContainer<KomitentObjekatUpisnoMesto> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<KomitentObjekatUpisnoMesto>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) { 
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
